"use client";
import { useEffect } from "react";
import { captureAdsAttribution } from "./ads-attribution-client";

export const SetUtmCookieComponent = ({
  source,
  campaign,
  medium,
}: {
  source?: string;
  campaign?: string;
  medium?: string;
}) => {
  useEffect(() => {
    captureAdsAttribution({ source, campaign, medium });
  }, [source, campaign, medium]);

  return null;
};
